/** Biblioteca de iconos para botones: iconos vectoriales que heredan el color del texto (no emojis). */
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ImageIcon from "@material-ui/icons/Image";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import DeleteIcon from "@material-ui/icons/Delete";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import FlagIcon from "@material-ui/icons/Flag";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import SearchIcon from "@material-ui/icons/Search";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MenuIcon from "@material-ui/icons/Menu";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import WarningIcon from "@material-ui/icons/Warning";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import SendIcon from "@material-ui/icons/Send";
import ShareIcon from "@material-ui/icons/Share";
import LinkIcon from "@material-ui/icons/Link";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import RefreshIcon from "@material-ui/icons/Refresh";
import GetAppIcon from "@material-ui/icons/GetApp";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import InputIcon from "@material-ui/icons/Input";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CategoryIcon from "@material-ui/icons/Category";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import HourglassEmptyOutlinedIcon from "@material-ui/icons/HourglassEmptyOutlined";
import StorageOutlinedIcon from "@material-ui/icons/StorageOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import BarChartOutlinedIcon from "@material-ui/icons/BarChartOutlined";
import FlashOnOutlinedIcon from "@material-ui/icons/FlashOnOutlined";
import PublicOutlinedIcon from "@material-ui/icons/PublicOutlined";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import PanToolOutlinedIcon from "@material-ui/icons/PanToolOutlined";
import MouseIcon from "@material-ui/icons/Mouse";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import PauseIcon from "@material-ui/icons/Pause";
import StopIcon from "@material-ui/icons/Stop";
import VolumeUpOutlinedIcon from "@material-ui/icons/VolumeUpOutlined";
import MicNoneOutlinedIcon from "@material-ui/icons/MicNoneOutlined";
import HeadsetOutlinedIcon from "@material-ui/icons/HeadsetOutlined";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import ExploreOutlinedIcon from "@material-ui/icons/ExploreOutlined";
import MyLocationOutlinedIcon from "@material-ui/icons/MyLocationOutlined";
import FilterCenterFocusOutlinedIcon from "@material-ui/icons/FilterCenterFocusOutlined";
import GestureIcon from "@material-ui/icons/Gesture";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VolumeOffOutlinedIcon from "@material-ui/icons/VolumeOffOutlined";
import ReplayIcon from "@material-ui/icons/Replay";

export const BUTTON_ICON_LIBRARY = [
	// Navegación y flechas
	{ id: "arrowRight", label: "Flecha derecha", Icon: ArrowForwardIcon },
	{ id: "arrowForward", label: "Flecha adelante", Icon: ArrowForwardIcon },
	{ id: "arrowBack", label: "Flecha atrás", Icon: ArrowBackIcon },
	{ id: "arrowLeft", label: "Flecha izquierda", Icon: ArrowBackIcon },
	{ id: "arrowUp", label: "Flecha arriba", Icon: ArrowUpwardIcon },
	{ id: "arrowDown", label: "Flecha abajo", Icon: ArrowDownwardIcon },
	{ id: "chevronRight", label: "Chevron derecha", Icon: ArrowForwardIcon },
	{ id: "chevronLeft", label: "Chevron izquierda", Icon: ArrowBackIcon },
	{ id: "doubleArrow", label: "Doble flecha", Icon: DoubleArrowIcon },
	// Interacción / pulsar
	{ id: "touch", label: "Pulsar / tocar", Icon: TouchAppIcon },
	{ id: "touchOutlined", label: "Pulsar (contorno)", Icon: TouchAppOutlinedIcon },
	{ id: "hand", label: "Mano", Icon: PanToolOutlinedIcon },
	{ id: "mouse", label: "Ratón / clic", Icon: MouseIcon },
	{ id: "gesture", label: "Gesto / deslizar", Icon: GestureIcon },
	{ id: "fingerprint", label: "Huella / identificar", Icon: FingerprintIcon },
	{ id: "focus", label: "Enfoque / objetivo", Icon: FilterCenterFocusOutlinedIcon },
	{ id: "select", label: "Seleccionar", Icon: RadioButtonCheckedIcon },
	// Reproducción y medios
	{ id: "play", label: "Reproducir", Icon: PlayArrowIcon },
	{ id: "playArrow", label: "Reproducir", Icon: PlayArrowIcon },
	{ id: "pause", label: "Pausa", Icon: PauseIcon },
	{ id: "stop", label: "Detener", Icon: StopIcon },
	{ id: "replay", label: "Repetir", Icon: ReplayIcon },
	{ id: "image", label: "Imagen", Icon: ImageIcon },
	{ id: "video", label: "Vídeo", Icon: VideoLibraryIcon },
	{ id: "camera", label: "Cámara", Icon: CameraAltOutlinedIcon },
	{ id: "volume", label: "Volumen / audio", Icon: VolumeUpOutlinedIcon },
	{ id: "volumeOff", label: "Silencio", Icon: VolumeOffOutlinedIcon },
	{ id: "mic", label: "Micrófono", Icon: MicNoneOutlinedIcon },
	{ id: "headset", label: "Auriculares", Icon: HeadsetOutlinedIcon },
	// Acciones principales
	{ id: "check", label: "Comprobar", Icon: CheckIcon },
	{ id: "doneAll", label: "Todo listo", Icon: DoneAllIcon },
	{ id: "close", label: "Cerrar", Icon: ClearIcon },
	{ id: "add", label: "Añadir", Icon: AddIcon },
	{ id: "remove", label: "Quitar", Icon: RemoveIcon },
	{ id: "delete", label: "Eliminar", Icon: DeleteIcon },
	{ id: "edit", label: "Editar", Icon: EditOutlinedIcon },
	{ id: "copy", label: "Copiar", Icon: FileCopyIcon },
	{ id: "undo", label: "Deshacer", Icon: UndoIcon },
	{ id: "redo", label: "Rehacer", Icon: RedoIcon },
	// Ideas y contenido
	{ id: "lightbulb", label: "Bombilla / Idea", Icon: EmojiObjectsIcon },
	{ id: "star", label: "Estrella", Icon: StarBorderIcon },
	{ id: "lock", label: "Candado", Icon: LockOutlinedIcon },
	{ id: "lockOpen", label: "Candado abierto", Icon: LockOpenOutlinedIcon },
	{ id: "flag", label: "Bandera", Icon: FlagIcon },
	{ id: "trophy", label: "Trofeo", Icon: EmojiEventsIcon },
	{ id: "bookmark", label: "Marcador", Icon: BookmarkBorderIcon },
	{ id: "favorite", label: "Favorito", Icon: FavoriteBorderIcon },
	// Búsqueda y navegación
	{ id: "search", label: "Buscar", Icon: SearchIcon },
	{ id: "home", label: "Inicio", Icon: HomeOutlinedIcon },
	{ id: "location", label: "Ubicación", Icon: LocationOnIcon },
	{ id: "explore", label: "Explorar / brújula", Icon: ExploreOutlinedIcon },
	{ id: "myLocation", label: "Mi ubicación", Icon: MyLocationOutlinedIcon },
	{ id: "menu", label: "Menú", Icon: MenuIcon },
	{ id: "moreHoriz", label: "Más opciones", Icon: MoreHorizIcon },
	{ id: "moreVert", label: "Más vertical", Icon: MoreVertIcon },
	{ id: "zoomIn", label: "Acercar", Icon: ZoomInIcon },
	{ id: "zoomOut", label: "Alejar", Icon: ZoomOutIcon },
	{ id: "fullscreen", label: "Pantalla completa", Icon: FullscreenIcon },
	// Información y ayuda
	{ id: "info", label: "Información", Icon: InfoOutlinedIcon },
	{ id: "help", label: "Ayuda", Icon: HelpOutlineIcon },
	{ id: "warning", label: "Advertencia", Icon: WarningIcon },
	{ id: "expandMore", label: "Expandir abajo", Icon: ExpandMoreIcon },
	{ id: "expandLess", label: "Expandir arriba", Icon: ExpandLessIcon },
	// Comunicación y compartir
	{ id: "send", label: "Enviar", Icon: SendIcon },
	{ id: "share", label: "Compartir", Icon: ShareIcon },
	{ id: "link", label: "Enlace", Icon: LinkIcon },
	{ id: "openInNew", label: "Abrir en nueva ventana", Icon: OpenInNewIcon },
	{ id: "mail", label: "Correo", Icon: MailOutlineIcon },
	{ id: "phone", label: "Teléfono", Icon: PhoneIcon },
	{ id: "notifications", label: "Notificaciones", Icon: NotificationsNoneIcon },
	// Configuración y usuario
	{ id: "settings", label: "Ajustes", Icon: SettingsOutlinedIcon },
	{ id: "visibility", label: "Visibilidad", Icon: VisibilityOutlinedIcon },
	{ id: "visibilityOff", label: "Ocultar", Icon: VisibilityOffOutlinedIcon },
	{ id: "refresh", label: "Actualizar", Icon: RefreshIcon },
	{ id: "download", label: "Descargar", Icon: GetAppIcon },
	{ id: "schedule", label: "Calendario / Horario", Icon: ScheduleIcon },
	{ id: "thumbUp", label: "Me gusta", Icon: ThumbUpOutlinedIcon },
	{ id: "thumbDown", label: "No me gusta (contorno)", Icon: ThumbDownOutlinedIcon },
	{ id: "thumbDownAlt", label: "No me gusta (mano)", Icon: ThumbDownAltOutlinedIcon },
	{ id: "community", label: "Comunidad / personas", Icon: PeopleOutlineIcon },
	{ id: "group", label: "Grupo", Icon: GroupOutlinedIcon },
	{ id: "friends", label: "Gente / celebración", Icon: EmojiPeopleIcon },
	{ id: "timer", label: "Cronómetro", Icon: TimerOutlinedIcon },
	{ id: "hourglass", label: "Cuenta atrás / reloj arena", Icon: HourglassEmptyOutlinedIcon },
	{ id: "storage", label: "Datos / almacenamiento", Icon: StorageOutlinedIcon },
	{ id: "vpnKey", label: "Acceso / clave", Icon: VpnKeyOutlinedIcon },
	{ id: "forum", label: "Foro / debate", Icon: ForumOutlinedIcon },
	{ id: "barChart", label: "Gráfico / estadísticas", Icon: BarChartOutlinedIcon },
	{ id: "flashOn", label: "Rayo / urgencia", Icon: FlashOnOutlinedIcon },
	{ id: "public", label: "Mundo / global", Icon: PublicOutlinedIcon },
	{ id: "equalizer", label: "Niveles / competición", Icon: EqualizerIcon },
	{ id: "login", label: "Entrar", Icon: InputIcon },
	{ id: "logout", label: "Salir", Icon: ExitToAppIcon },
	// Categorías y contenido
	{ id: "category", label: "Categoría", Icon: CategoryIcon },
	{ id: "viewModule", label: "Cuadrícula", Icon: ViewModuleIcon },
	{ id: "assignment", label: "Tarea", Icon: AssignmentIcon },
];

const map = Object.fromEntries(BUTTON_ICON_LIBRARY.map(({ id, Icon }) => [id, Icon]));
export const BUTTON_ICON_MAP = { ...map, arrowRight: ArrowForwardIcon };
